import { home } from "./src/Home";

(function (Drupal) {
	'use strict';
	
	Drupal.behaviors.home = home;
}(Drupal));